import ImporterCSV from './ImporterCSV';
import ImporterNMEA from './ImporterNMEA';
import ImporterXML from './ImporterXML';
import ImporterGPX from './ImporterGPX';
import ImporterKML from './ImporterKML';

export default class ImporterFactory {
  constructor(fileName, fileData, customEventDefinition) {
    this.fileName = fileName;
    this.fileData = fileData;
    this.customEventDefinition = customEventDefinition;
    let decomposedFileName = ImporterFactory._decomposeFileName(fileName);
    switch (decomposedFileName.extension) {
      case 'csv':
      default:
        return new ImporterCSV(fileName, fileData, customEventDefinition);
      case 'nmea':
        return new ImporterNMEA(fileName, fileData);
      case 'xml':
        return new ImporterXML(fileName, fileData);
      case 'gpx':
        return new ImporterGPX(fileName, fileData);
      case 'kml':
      case 'KML':
        return new ImporterKML(fileName, fileData);
    }
  }

  static _decomposeFileName(fileName) {
    // eslint-disable-next-line no-bitwise
    let extension = fileName.slice((fileName.lastIndexOf('.') - 1 >>> 0) + 2);

    return {
      name: fileName.replace('.' + extension, ''),
      extension: extension
    };
  }
}
if (typeof window !== 'undefined') window.ImporterFactory = ImporterFactory;
module.exports = ImporterFactory;
